export const DATE_FORMATS = {
  parse: {
    dateInput: ['dd.MM.yyyy', 'dd-MM-yyyy', 'dd/MM/yyyy', 'dd MM yyyy'],
  },
  display: {
    dateInput: 'dd.MM.yyyy',
    monthYearLabel: 'LLL yyyy', // or 'LLL. yyyy' if you want short month names
    dateA11yLabel: 'd LLLL yyyy', // e.g., "15 august 2025"
    monthYearA11yLabel: 'LLLL yyyy',
  },
};

export const MONTH_AND_YEAR_ONLY_FORMATS = {
  parse: {
    dateInput: ['MM.yyyy'],
  },
  display: {
    dateInput: 'MM.yyyy',
    monthYearLabel: 'LLL yyyy',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'LLLL yyyy',
  },
};
